import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPixelEvent } from "../services/metaPixel";

const MetaPixelRouteTracker: React.FC = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      // index.html's inline bootstrap already fires the initial PageView on
      // consent grant; skip it here to avoid double-counting.
      isFirstRender.current = false;
      return;
    }
    trackMetaPixelEvent("PageView");
  }, [location.pathname]);

  return null;
};

export default MetaPixelRouteTracker;
